module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"en":{"title":"Thanks for your response!","description":"The option selected on email was registered with success.","developed":"Developed by","wepipe-forms":"wepipe forms"},"pt-BR":{"title":"Obrigado por responder!","description":"A opção selecionada no e-mail foi registrada com sucesso.","developed":"Desenvolvido por","wepipe-forms":"wepipe forms"}}')
  delete Component.options._Ctor
}
